<app-color-list-preview [colorList]="colorSet" [showDetailsOnClick]="showDetailColor" [maximumCreelPositionsToShow]="8"> </app-color-list-preview>
